export const FOCUS_FIELD_PARAM = 'focus';

export const getFieldLocation = (fieldCode, fieldPathIndex, sections = []) => {
  const fieldPath = fieldPathIndex?.[fieldCode];
  if (!fieldPath?.sectionCode) return null;

  const section = sections.find(
    candidateSection => candidateSection.code === fieldPath.sectionCode,
  );
  if (!section) return null;

  if (section.singlePage) {
    return { sectionCode: section.code, pageIndex: 0 };
  }

  const subsectionPosition = (section.subsections || []).findIndex(
    subsection => subsection.code === fieldPath.subsectionCode,
  );
  if (subsectionPosition === -1) return null;

  return {
    sectionCode: section.code,
    pageIndex: subsectionPosition + (section.indexPage ? 1 : 0),
  };
};

export const buildFieldPath = ({ sectionCode, pageIndex, token, fieldCode }) =>
  `/form_submission/candidate/${sectionCode}/${token}/page/${pageIndex}?${FOCUS_FIELD_PARAM}=${fieldCode}`;
